import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getEnvironmentsforUser } from '../api/documentAPI';
import { useNotification } from '../context/NotificationContext';
import { NotificationType } from '../enums/NotificationType';

import axios from '../api/axios';
import useCookie from "../hooks/useCookie";
import useAuth from '../hooks/useAuth';

const LoginAgent = () => {

  const navigate = useNavigate();

  const { showNotification } = useNotification();
  const { setAuth, setUserType, setUserLang } = useAuth();

  const [t] = useTranslation('global'); 
  const [isLoading, setIsLoading] = useState(false);
  const [envCookie, setEnvCookie, ] = useCookie("ENV");  

  useEffect(() => {
    setIsLoading(true);
    const lang = new URLSearchParams(window.location.search).get('lang'); 
    if (lang) {
      setUserLang(lang); 
    }

    handleLoginNoAuth(document.location.toString());
    console.log(document.location.toString());
  },[]);

  useEffect(() => {
    console.log(isLoading)
  },[isLoading])

  // /LoginAgent?agentid=2&lang=sk
  const handleLoginNoAuth =  async (urlLocation) => {
    try {
      const { data: user } = await axios.post("/api/auth/NoAuthenticate", {Url: urlLocation}, { withCredentials: true });
      await handlePostLogin(user);
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      if (errorMessage) {
        navigate("/error", { state: { errorMessage } });
      } else {
        showNotification({ message: 'Vyskytla sa chyba.', type: NotificationType.Error });
      }
    }
  }


  const handlePostLogin = async (user) => {

    const { id, userFirstname, userLastname, userEmail, isActive, roleId } = user;
    setAuth({ 
      uid: id, 
      ufn: userFirstname, 
      uln: userLastname, 
      uem: userEmail, 
      uia: isActive, 
      uri: roleId 
    });
    setUserType("agent");

    await validateAndSetCookie();
    navigate("/Wizard");
    setIsLoading(false);
  };

  // agent nepotrebuje env cookie! vzdy ide cez wizard
  const validateAndSetCookie = async () => {
    try {
      const environments = await getEnvironmentsforUser(); 

      if (!envCookie || !isValidEnvForUser(envCookie, environments)) {
        const defaultEnv = environments[0]?.Id || null; 
        if (defaultEnv) {
          setEnvCookie("ENV", defaultEnv, { maxAge: 86400 });
        }
      }
    } catch (error) {
      console.error("Error validating environment cookie:", error);
    }
  }

  const isValidEnvForUser = (envCookie, environments) => {
    const value =  environments.some(env => env.Id === envCookie);
    return value;
  };

  return (
    <>
    {/* <span>{t('loading')} </span> */}
      <div className='center-loader'>
        {isLoading && (
          <>
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default LoginAgent;
